
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";
//import { PermissionService } from "@/services";
import ScrollableContent from "@/components/ScrollableContent.vue";

export default defineComponent({
  name: "kt-menu",
  components: { ScrollableContent },
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      if (!match) return false;

      if (!match.sub) return false;

      if (!route.name) return false;

      let hasMatch = false;
      match.sub.forEach((x) => {
        hasMatch = x.routeName == route.name;
        if (hasMatch) return;
      });

      return hasMatch;
    };

    const userHasPermission = (permissions: string[]) => {
      let hasPermission = true;
      // permissions.forEach((permission) => {
      //   hasPermission = PermissionService.hasPermission(permission);
      //   if (hasPermission) return;
      // });

      return hasPermission;
    };

    return {
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      version,
      translate,
      userHasPermission,
    };
  },
});
